var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame13(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 48096358"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4256",
    width: 6.875,
    height: 6.875,
    rx: 3.4375,
    transform: "matrix(-1 0 0 1 19.5 4.5)",
    fill: "#C3FAFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4256_2",
    width: 6.875,
    height: 6.875,
    rx: 0.75,
    transform: "matrix(-1 0 0 1 19.5 12.625)",
    fill: "#89C1FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4256_3",
    width: 6.875,
    height: 6.875,
    rx: 0.75,
    transform: "matrix(-1 0 0 1 11.3749 4.5)",
    fill: "#89C1FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4256_4",
    width: 6.875,
    height: 6.875,
    rx: 0.75,
    transform: "matrix(-1 0 0 1 11.3749 12.625)",
    fill: "#89C1FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame13);
export default __webpack_public_path__ + "static/media/Frame 13.6f12dc570de4d4d998b6d2aeb51d8f98.svg";
export { ForwardRef as ReactComponent };